import { BigNumber } from "ethers";
import { Trait } from "types";
import traits from "config/traits.csv";

export const fetchTraits = async (): Promise<Trait[]> => {
  return traits.map(([tokenId, name]: [number, string]) => ({
    tokenId,
    name,
    honeyConsumptionRequirement: BigNumber.from("0"),
  }));
};
